<template>
  <div
    v-if="mp4 || webm"
    class="candidate-video"
  >
    <video
      v-show="!failed"
      :key="playerKey"
      :width="width"
      controls
      preload="metadata"
      playsinline
      @error="onError"
    >
      <source
        v-if="webm"
        :src="webm"
        type='video/webm; codecs="vp9, opus"'
      >
      <source
        v-if="mp4"
        :src="mp4"
        type='video/mp4; codecs="avc1, mp4a.40.2"'
      >
    </video>
    <v-alert
      v-if="failed"
      type="warning"
      role="alert"
      dense
    >
      Video sa v tomto prehliadači nepodarilo prehrať.
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "CandidateVideo",
  props: {
    mp4: {
      type: String,
      default: null,
    },
    webm: {
      type: String,
      default: null,
    },
    width: {
      type: [Number, String],
      default: "100%",
    },
    reloadKey: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    failed: false,
  }),
  computed: {
    sourceKey() {
      return `${this.webm || ""}|${this.mp4 || ""}`;
    },
    playerKey() {
      return `${this.sourceKey}|${this.reloadKey}`;
    },
  },
  watch: {
    playerKey() {
      this.failed = false;
    },
  },
  methods: {
    onError() {
      this.failed = true;
      this.$emit("playback-error");
    },
  },
};
</script>
